export default "__VITE_ASSET__DtEDfP34__"